import { render, staticRenderFns } from "./Distrito.vue?vue&type=template&id=57e0f2dc"
import script from "./Distrito.vue?vue&type=script&lang=ts"
export * from "./Distrito.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports